import { useCallback } from "react";
import { useCashAvailable } from "hooks/firestore/user/useAccountBalances";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";

/**
 * Wrapper hooks that subscribe to the user's promo balance via
 * `useCashAvailable` and inject it into the stakes-slice actions.
 * Components consume these instead of reading the raw actions, so
 * promo-balance clamping math stays consistent with what the user
 * actually has available.
 */

export const useSetSingleStake = () => {
  const setSingleStake = useBetslipStore((state) => state.setSingleStake);
  const { promo } = useCashAvailable();
  return useCallback(
    (outcomeId: string, amount: number) =>
      setSingleStake(outcomeId, amount, promo),
    [setSingleStake, promo],
  );
};

export const useSetMultiStake = () => {
  const setMultiStake = useBetslipStore((state) => state.setMultiStake);
  const { promo } = useCashAvailable();
  return useCallback(
    (amount: number) => setMultiStake(amount, promo),
    [setMultiStake, promo],
  );
};

export const useSetStakeAll = () => {
  const setStakeAll = useBetslipStore((state) => state.setStakeAll);
  const { promo } = useCashAvailable();
  return useCallback(
    (amount: number) => setStakeAll(amount, promo),
    [setStakeAll, promo],
  );
};
